import React from 'react';
import { Box } from '@material-ui/core';
import Loader from 'shared/components/Loader';
import { useStyles } from './styles';

export default function LoadingPlaceholder() {
  const classes = useStyles();

  return (
    <Box className={classes.wrapper}>
      <Loader />
    </Box>
  );
}
